import p1_img from "./product_1.png";
import p10_img from "./product_10.png";
import p11_img from "./product_11.png";
import p12_img from "./product_12.png";
import p13_img from "./product_13.png";
import p14_img from "./product_14.png";
import p15_img from "./product_15.png";
import p16_img from "./product_16.png";
import p17_img from "./product_17.png";
import p18_img from "./product_18.png";
import p19_img from "./product_19.png";
import p2_img from "./product_2.png";
import p20_img from "./product_20.png";
import p21_img from "./product_21.png";
import p22_img from "./product_22.png";
import p23_img from "./product_23.png";
import p24_img from "./product_24.png";
import p25_img from "./product_25.png";
import p26_img from "./product_26.png";
import p27_img from "./product_27.png";
import p28_img from "./product_28.png";
import p29_img from "./product_29.png";
import p3_img from "./product_3.png";
import p30_img from "./product_30.png";
import p31_img from "./product_31.png";
import p32_img from "./product_32.png";
import p33_img from "./product_33.png";
import p34_img from "./product_34.png";
import p35_img from "./product_35.png";
import p36_img from "./product_36.png";
import p4_img from "./product_4.png";
import p5_img from "./product_5.png";
import p6_img from "./product_6.png";
import p7_img from "./product_7.png";
import p8_img from "./product_8.png";
import p9_img from "./product_9.png";

let all_product = [
  {
    id: 1,
    name: "Elegant Women's Three-Piece Formal Suit Set",
    category: "women",
    image: p1_img,
    new_price: 50.0,
    old_price: 80.5,
  },
  {
    id: 2,
    name: "Boho Chic Women's Peasant Frock Dress",
    category: "women",
    image: p2_img,
    new_price: 75.0,
    old_price: 100.5,
  },
  {
    id: 3,
    name: "Classic Women's Cotton T-Shirt for Everyday Comfort",
    category: "women",
    image: p3_img,
    new_price: 40.0,
    old_price: 70.5,
  },
  {
    id: 4,
    name: "Trendy Women's Casual Button-Up Shirt",
    category: "women",
    image: p4_img,
    new_price: 65.0,
    old_price: 90.0,
  },
  {
    id: 5,
    name: "Stylish Women's High-Waist Skinny Jeans",
    category: "women",
    image: p5_img,
    new_price: 60.0,
    old_price: 95.5,
  },
  {
    id: 6,
    name: "Graceful Women's Pleated Midi Skirt",
    category: "women",
    image: p6_img,
    new_price: 55.0,
    old_price: 85.0,
  },
  {
    id: 7,
    name: "Elegant Women's Wide-Leg Palazzo Pants",
    category: "women",
    image: p7_img,
    new_price: 70.0,
    old_price: 110.0,
  },
  {
    id: 8,
    name: "Comfortable Women's Nightwear Set",
    category: "women",
    image: p8_img,
    new_price: 45.0,
    old_price: 80.0,
  },
  {
    id: 9,
    name: "Sophisticated Women's Long Wool Coat",
    category: "women",
    image: p9_img,
    new_price: 120.0,
    old_price: 150.0,
  },
  {
    id: 10,
    name: "Premium Women's Genuine Leather Biker Jacket",
    category: "women",
    image: p10_img,
    new_price: 110.0,
    old_price: 140.5,
  },
  {
    id: 11,
    name: "Classic Women's Denim Jacket for Casual Outfits",
    category: "women",
    image: p11_img,
    new_price: 90.0,
    old_price: 130.5,
  },
  {
    id: 12,
    name: "Cozy Women's Sportswear Sweater for Outdoor Activities",
    category: "women",
    image: p12_img,
    new_price: 75.0,
    old_price: 110.0,
  },
  {
    id: 13,
    name: "Men's Casual Cotton T-Shirt for Everyday Wear",
    category: "men",
    image: p13_img,
    new_price: 55.0,
    old_price: 85.5,
  },
  {
    id: 14,
    name: "Men's Checkered Button-Down Shirt for a Stylish Look",
    category: "men",
    image: p14_img,
    new_price: 70.0,
    old_price: 100.5,
  },
  {
    id: 15,
    name: "Traditional Men's Panjabi with Intricate Embroidery",
    category: "men",
    image: p15_img,
    new_price: 75.0,
    old_price: 105.0,
  },
  {
    id: 16,
    name: "Solid Color Men's Dress Shirt for Formal Occasions",
    category: "men",
    image: p16_img,
    new_price: 60.0,
    old_price: 95.0,
  },
  {
    id: 17,
    name: "Men's Tailored Formal Trousers for Professional Wear",
    category: "men",
    image: p17_img,
    new_price: 80.0,
    old_price: 120.5,
  },
  {
    id: 18,
    name: "Men's Tailored Fit Trousers for Business Casual",
    category: "men",
    image: p18_img,
    new_price: 75.0,
    old_price: 110.0,
  },
  {
    id: 19,
    name: "Men's Slim Fit Gavading Pants for a Modern Look",
    category: "men",
    image: p19_img,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 20,
    name: "Classic Men's Blue Jeans for Timeless Style",
    category: "men",
    image: p20_img,
    new_price: 90.0,
    old_price: 125.0,
  },
  {
    id: 21,
    name: "Basic Men's Jacket for Everyday Casual Wear",
    category: "men",
    image: p21_img,
    new_price: 100.0,
    old_price: 135.5,
  },
  {
    id: 22,
    name: "Men's Stylish Denim Jacket for a Rugged Look",
    category: "men",
    image: p22_img,
    new_price: 95.0,
    old_price: 130.0,
  },
  {
    id: 23,
    name: "Men's Long Wool Coat for Winter Elegance",
    category: "men",
    image: p23_img,
    new_price: 115.0,
    old_price: 150.0,
  },
  {
    id: 24,
    name: "Men's Premium Leather Jacket for a Sleek Style",
    category: "men",
    image: p24_img,
    new_price: 125.0,
    old_price: 160.5,
  },
  {
    id: 25,
    name: "Adorable Kid's Frock for Playtime and Parties",
    category: "kid",
    image: p25_img,
    new_price: 40.0,
    old_price: 70.0,
  },
  {
    id: 26,
    name: "Sporty Kid's Jersey for Active Days",
    category: "kid",
    image: p26_img,
    new_price: 55.0,
    old_price: 90.5,
  },
  {
    id: 27,
    name: "Traditional Arabian Alkhalla Dress for Kids",
    category: "kid",
    image: p27_img,
    new_price: 65.0,
    old_price: 100.0,
  },
  {
    id: 28,
    name: "Smart Kid's Three-Piece Suit for Formal Occasions",
    category: "kid",
    image: p28_img,
    new_price: 50.0,
    old_price: 85.5,
  },
  {
    id: 29,
    name: "Trendy Kid's Jeans for Everyday Comfort",
    category: "kid",
    image: p29_img,
    new_price: 45.0,
    old_price: 75.0,
  },
  {
    id: 30,
    name: "Comfortable Kid's Gavading Pants for Daily Wear",
    category: "kid",
    image: p30_img,
    new_price: 40.0,
    old_price: 70.0,
  },
  {
    id: 31,
    name: "Denim Kid's Jumpsuit for a Playful Look",
    category: "kid",
    image: p31_img,
    new_price: 60.0,
    old_price: 95.0,
  },
  {
    id: 32,
    name: "Charming Kid's Denim Jacket for Cool Days",
    category: "kid",
    image: p32_img,
    new_price: 55.0,
    old_price: 85.0,
  },
  {
    id: 33,
    name: "Kid's Lightweight Windbreaker for Active Outdoor Fun",
    category: "kid",
    image: p33_img,
    new_price: 75.0,
    old_price: 110.0,
  },
  {
    id: 34,
    name: "Stylish Kid's Wool Coat for Cold Winter Days",
    category: "kid",
    image: p34_img,
    new_price: 85.0,
    old_price: 120.0,
  },
  {
    id: 35,
    name: "Elegant Kid's Long Wool Coat for Special Events",
    category: "kid",
    image: p35_img,
    new_price: 95.0,
    old_price: 125.0,
  },
  {
    id: 36,
    name: "Kid's Classic Leather Jacket for a Cool Look",
    category: "kid",
    image: p36_img,
    new_price: 90.0,
    old_price: 130.0,
  },
];

export default all_product;